import { get } from "lodash";

export default {
  getResponse: state => (id, fallback = null) =>
    get(
      state.responses.find(response => response.id === id),
      "value",
      fallback
    ),

  hasResponse: state => id => {
    return state.responses.some(response => response.id === id);
  },

  getResponseSubmission: state => ({
    data: JSON.parse(JSON.stringify(state.responses)),
    submission_token: state.submission_token,
  }),
};
